import React from "react";
import styled from "styled-components";
import { Modal, Row, Col, Card, Button } from "antd";
import { CustomLabel } from "../../../../Common/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import PAGE_CONSTANTS from "../constant";
import "./appointmentModal.css";

const YesButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 50px;
  border-radius: 40px;
  border: solid 0.5px #f26221;
  margin-top: 10px;
  text-align: center;
  background-image: ${(props) =>
    props.disable ? "" : "linear-gradient(to top, #f26221, #f5851f)"};
  .ant-btn-text[disabled] {
    color: #f26221 !important;
    font-weight: bold;
  }
  .ant-btn-text {
    color: white !important;
    font-weight: bold;
  }
  &:hover {
    background-image: linear-gradient(to top, #f26221, #f5851f);
    .ant-btn-text[disabled] {
      color: white !important;
      font-weight: bold;
    }
  }
  @media (max-width: 768px) {
    width: 90px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
    .ant-btn-text[disabled] {
      font-size: 11px;
    }
    .ant-btn-text {
      font-size: 11px;
    }
  }
`;

const CancelButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 50px;
  border-radius: 40px;
  border: solid 2px #f47720;
  margin-top: 10px;
  margin-right: 20px;
  text-align: center;
  .ant-btn-text[disabled] {
    color: #f26221 !important;
    font-weight: bold;
  }
  .ant-btn-text {
    color: #f47720 !important;
    font-weight: bold;
  }
  &:hover {
    .ant-btn-text[disabled] {
      color: #f47720 !important;
      font-weight: bold;
    }
  }
  @media (max-width: 768px) {
    width: 90px;
    height: 35px;
    border-radius: 17.5px;
    padding: 12px 2px;
    .ant-btn-text[disabled] {
      font-size: 11px;
    }
    .ant-btn-text {
      font-size: 11px;
    }
  }
`;

const renderProceedBooking = (
  email,
  mobile,
  date,
  time,
  address,
  dcContactNo,
  clinicName,
  onCancel,
  onClickYes,
  isHouseVisit
) => {
  return (
    <Card>
      <Row gutter={[20, 20]}>
        <Col md={24} className="title">
          <CustomLabel font_size="24" font_weight="bold">
            {`Do you want to proceed with booking the appointment?`}
          </CustomLabel>
        </Col>
        <Col md={24} className="subtitle">
          <CustomLabel font_size="18" font_weight="bold">
            {`VENUE`}
          </CustomLabel>
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={12}>
          <div className="address-block">
            <Row>
              <CustomLabel font_size="14" font_weight="bold">
                {isHouseVisit ? "Home Address" : clinicName}
              </CustomLabel>
            </Row>
            <Row gutter={[12, 10]}>
              <Col xs={24} style={{ marginTop: "9px" }}>
                <Row>
                  <div className="flex">
                    <Col xs={2}>
                      <span
                        className="start_icon flex"
                        style={{ fontSize: "20px" }}
                      >
                        <i className="fa fa-map-marker" aria-hidden="true"></i>
                      </span>
                    </Col>
                    <Col xs={22}>
                      <CustomLabel font_size="14" font_weight="normal">
                        {address}
                      </CustomLabel>
                    </Col>
                  </div>
                </Row>
                {!isHouseVisit && dcContactNo && (
                  <Row>
                    <div className="justify-flex-center w-100">
                      <Col xs={2} style={{ marginTop: "9px" }}>
                        <span
                          className="start_icon"
                          style={{ fontSize: "20px" }}
                        >
                          <i className="fa fa-phone" aria-hidden="true"></i>
                        </span>
                      </Col>
                      <Col xs={22} style={{ marginTop: "9px" }}>
                        <CustomLabel font_size="14" font_weight="normal">
                          {dcContactNo}
                        </CustomLabel>
                      </Col>
                    </div>
                  </Row>
                )}
              </Col>
            </Row>
          </div>
        </Col>
        <Col xs={24} md={12}>
          <Row className="date-time-row">
            <Col xs={12}>
              <Row>
                <Col xs={24}>
                  <CustomLabel font_size="14" font_weight="bold">
                    {"Date"}
                  </CustomLabel>
                </Col>
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "16px" }}>
                      <i
                        className="fa fa-calendar-check-o"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-3"
                      font_size="14"
                      font_weight="bold"
                    >
                      {date}
                    </CustomLabel>
                  </Col>
                </div>
              </Row>
            </Col>
            <Col xs={12}>
              <Row>
                <Col xs={24}>
                  <CustomLabel font_size="14" font_weight="bold">
                    {"Time"}
                  </CustomLabel>
                </Col>
                <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "18px" }}>
                      <i className="fa fa-clock-o" aria-hidden="true"></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-3"
                      font_size="14"
                      font_weight="bold"
                    >
                      {`${time?.hour}:${time?.minute} ${time?.meridiem}`}
                    </CustomLabel>
                  </Col>
                </div>
              </Row>
            </Col>
          </Row>
          <Row className="mobile-email-row">
            <Col xs={12}>
              <Row>
                <Col xs={24}>
                  <CustomLabel font_size="14" font_weight="bold">
                    {"Mobile Number"}
                  </CustomLabel>
                </Col>
              {mobile && <div className="justify-flex-center h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "24px" }}>
                      <i className="fa fa-mobile" aria-hidden="true"></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <CustomLabel
                      className="ml-2"
                      font_size="14"
                      font_weight="normal"
                    >
                      {mobile || "NA"}
                    </CustomLabel>
                  </Col>
                </div>}
              </Row>
            </Col>
            <Col xs={12}>
              <Row>
                <Col xs={24}>
                  <CustomLabel font_size="14" font_weight="bold">
                    {"Email ID"}
                  </CustomLabel>
                </Col>
                <div className="display-contents h-25">
                  <Col xs={2}>
                    <span className="start_icon" style={{ fontSize: "16px" }}>
                      <i className="fa fa-envelope" aria-hidden="true"></i>
                    </span>
                  </Col>
                  <Col xs={22}>
                    <div className="ml-3">
                      <CustomLabel font_size="14" font_weight="normal">
                        {email || "NA"}
                      </CustomLabel>
                    </div>
                  </Col>
                </div>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="modal-btn-wrapper">
        <Col xs={24}>
          <div className="justify-flex-center">
            <CancelButton disable={false}>
              <Button onClick={onCancel} type="text" disabled={false}>
                {"CANCEL"}
                <FontAwesomeIcon icon={faAngleRight} className="right-icon" />
              </Button>
            </CancelButton>
            <YesButton disable={false}>
              <Button onClick={onClickYes} type="text" disabled={false}>
                {"YES"}
                <FontAwesomeIcon icon={faAngleRight} className="right-icon" />
              </Button>
            </YesButton>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

const AppointmentModal = ({
  open,
  onClose,
  address,
  email,
  mobile,
  date,
  time,
  dcContactNo = "",
  clinicName = "",
  appointmentType,
  onBooking,
}) => {
  const isHouseVisit = appointmentType === PAGE_CONSTANTS?.HOME_VISIT_TYPE;

  return (
    <Modal
      style={{ top: 20 }}
      open={open}
      onCancel={onClose}
      closable={false}
      destroyOnClose
      zIndex="999"
      footer={null}
    >
      <div className="modal-wrapper">
        {renderProceedBooking(
          email,
          mobile,
          date,
          time,
          address,
          dcContactNo,
          clinicName,
          onClose,
          onBooking,
          isHouseVisit
        )}
      </div>
    </Modal>
  );
};

export default AppointmentModal;
